// QADeleteConfirmModal Component
// Confirmation modal for deleting Q&A items

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';
import './QADeleteConfirmModal.css';

export function QADeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  qa = null, // { id: string, question: string, answer: string }
  isLoading = false
}) {
  if (!qa) {
    return null;
  }

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Q&A"
      showCloseButton={true}
    >
      <div className="qa-delete-confirm-content">
        <p className="qa-delete-confirm-message">
          Are you sure you want to delete this Q&A item? This action cannot be undone.
        </p>
        {qa.question && (
          <div className="qa-delete-preview">
            <div className="qa-delete-question">
              <strong>Question:</strong> {qa.question}
            </div>
            {qa.answer && (
              <div className="qa-delete-answer">
                <strong>Answer:</strong> {qa.answer.length > 100 ? `${qa.answer.substring(0, 100)}...` : qa.answer}
              </div>
            )}
          </div>
        )}
        <div className="qa-delete-confirm-actions">
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="danger"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                Deleting...
              </>
            ) : (
              'Delete Q&A'
            )}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default QADeleteConfirmModal;